module.exports = __webpack_public_path__ + "static/front-80f536bfe9ffbcf19be6cb60281386b1.jpg";